// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Vu2Yl","rightAdornment":"Header_rightAdornment__1pN64"};